// GEL BÊTA le 07/10/2026. Voir docs/GEL_BETA.md.
// Architecture figée : paiement dual, Coco via settings, rôles user_roles/has_role, âge 18 soft, pas de Connect.
// Porte ouverte : corrections de retours testeurs uniquement sur ordre Hiti, lot unique, sans rouvrir ces règles.
// Interdit sans Hiti : tama-wip→main, édition client.ts / types.ts / .env / config.toml / previewAuthStorage.
import { Video } from "@/types/videos";
import { getCachedPlaybackUrl } from "@/services/playbackUrls";

/**
 * Résolution de l'URL de lecture, sans aucun appel réseau bloquant.
 * Partagé par tous les moteurs de lecture.
 */

/** URL de repli : fichier d'origine conservé pendant la migration Bunny. */
export function fallbackUrlOf(video: Video): string | null {
  return video.legacy_video_url || video.video_url || null;
}

/**
 * URL disponible immédiatement : cache de lot (tokens signés), puis URL HLS
 * non signée en base, puis fichier d'origine. Jamais d'attente réseau ici :
 * si rien n'est prêt, l'URL arrivera par abonnement.
 */
export function resolveImmediateUrl(video: Video): string | null {
  const cached = getCachedPlaybackUrl(video.id);
  if (cached) return cached;
  // Mux : flux HLS public dès que la vidéo est prête.
  if (video.provider === "mux") {
    if (video.processing_status !== "ready") return null;
    return video.hls_url || video.video_url || null;
  }
  if (video.provider !== "bunny") return video.video_url || null;
  const ready = video.processing_status === "ready";
  if (!ready) return fallbackUrlOf(video);
  const hls = video.hls_url;
  // Une URL signée périmée serait injouable : on attend celle du lot.
  if (hls && !hls.includes("token=")) return hls;
  // Vidéo Bunny prête mais HLS pas encore résolu : ne JAMAIS poser le MP4,
  // sinon il se télécharge en doublon du flux HLS qui suivra par abonnement.
  return null;
}
